import React from "react";
import styled from "styled-components";

const SelectWrapper = styled.div`
  margin-bottom: 25px;
  /* padding-right: 10px; */
  ${"" /* width: 100%; */}
  label {
    margin-bottom: 20px;
    display: block;
    /* font-size: 0.8rem; */
  }
`;
const Select = styled.select`
  display: ${({ display }) => display || "inline"};
  width: ${({ width }) => width || "100%"};
  height: ${({ height }) => height || "2.3125rem"};
  padding: ${({ padding }) => padding || "10px"};
  color: black;
  border-radius: ${({ bRadius }) => bRadius || 0};
  outline: none;
  background-color: ${({ bgColor }) => bgColor || "#fff"};
  option {
    border: 4px solid red;
    height: 3000px;
  }
`;

export default ({
  label,
  required,
  options,
  handleChange,
  disabled,
  error,
  name,
  placeholder,
  value,
  bRadius,
  display,
  padding,
  height,
  width,
  bgColor,
}) => {
  return (
    <SelectWrapper>
      <div className="select__options-parent">
        {label && (
          <label>
            {label}
            {required && (
              <span className="error" style={{ marginLeft: "5px" }}>
                *
              </span>
            )}
          </label>
        )}

        <div className="select__option--container">
          <Select
            onChange={handleChange}
            disabled={disabled}
            name={name}
            placeholder={placeholder}
            value={value}
            bRadius={bRadius}
            display={display}
            padding={padding}
            height={height}
            width={width}
            bgColor={bgColor}
            required={required}
          >
            <option value="">{placeholder}</option>
            {options.map((option, i) => (
              <option
                value={option.value}
                key={i}
                disabled={option.disabled || false}
              >
                {option.name}
              </option>
            ))}
          </Select>
        </div>

        {error ? <p className="error">{error}</p> : ""}
      </div>
    </SelectWrapper>
  );
};
